<div class="container">
    <h1 mat-dialog-title>{{"PermissionsRequiredLogin" | translate}}</h1>
    <div class="permission_grant_msg">
        <span><b>{{"PermissionsRequiredLoginDescription" | translate}}</b></span>
    </div>
    <div><b><span [innerHTML]="PermissionsRequiredMessage"></span></b></div>
</div>
